import { useContext } from 'react';
import { di } from 'react-magnetic-di';
import { useCurrentPreviewPanel } from '@atlassian/preview-panels-api';
import { JiraPreviewPanelsContext } from './PreviewPanelsProvider.tsx';

export const useIsIssuePreviewPanelOpen = () => {
	const panel = useCurrentPreviewPanel();
	return panel !== null && panel.type === 'jira-issue';
};

// Helper function to detect if we're in an iframe
const isInIframe = (): boolean => {
	di(window);
	if (__SERVER__) {
		return false;
	}

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return window !== window.top;
};

export const isIssueEmbedPreviewPanelOpen = () => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return isInIframe() && window.location.search.includes('previewPanels');
};

/**
 * Check if the component is wrapped in PreviewPanelProvider
 * @returns boolean
 */
export const useIsPreviewPanelContextAvailable = () => {
	const context = useContext(JiraPreviewPanelsContext);

	return !!context;
};

export const useIsNativeIssueViewPreviewPanel = () => {
	const panel = useCurrentPreviewPanel();
	return panel?.type === 'jira-issue' && panel?.id?.startsWith('jira-issue/');
};
